<template>
  <header>
    <div class="header-mask">
      <div class="header-content">
        <div class="cont-left">
          <div class="logo-box" @click="toLink('/')">
            <img src="@/image/index/logo-header.png" alt="回车课堂" />
          </div>
          <div class="nav-right">
            <div class="class-btn" :class="$route.name === 'index' ? '' :'unchecked'"  @click="toLink('/','首页')">首页</div>
            <div class="class-btn nav-news" :class="$route.name === 'multiplex' && $route.query.id == item.id ? '' :'unchecked'" v-for="(item,index) in navList" :key="index" @click="toLink(`/multiplex/?id=${item.id}`,item.name)"> {{item.name}}</div>
            <div class="class-btn" :class="$route.name === 'scene' || $route.name === 'sceneDetails' ? '' :'unchecked'" @click="toLink('/scene/','学习路线')">学习路线</div>
            <!-- <div class="class-btn" :class="$route.name === 'about'?'':'unchecked'"  @click="toLink('/about/','关于我们')">关于我们</div> -->
          </div>
        </div>
        <div class="cont-login-box">
          <div class="search-box">
            <div class="search-cont" @mousedown.stop>
              <input type="text" placeholder="搜索关键词/讲师" v-model.trim="searchData" @mousedown.stop @focus="showOtherSeaarch" @keyup.enter="searchFun()">
              <i @click="searchFun()"></i>
            </div>
            <div class="search-other" v-show="searchOtherFlag" @mousedown.stop>
              <h4>热搜</h4>
              <ul class="hot-list">
                <li v-for="(item,index) in hotList" :key="item.id" @click.stop="searchFun(item.hotWord)">
                  <i v-if="index < 3"></i>
                  <span>{{item.hotWord}}</span>
                </li>
              </ul>
              <div class="history-box" v-show="localHistoryList && localHistoryList.length > 0">
                <div class="history-title">
                  <h4>搜索记录</h4>
                  <span @click.stop="deleteHistory()">全部清除</span>
                </div>
                <ul class="history-list">
                  <li v-for="item in (localHistoryList && localHistoryList.length > 5 ? localHistoryList.slice(0, 5) : localHistoryList)" :key="item.name">
                    <span @click.stop="searchFun(item.name)" :title="item.name">{{item.name}}</span>
                    <i @click.stop="deleteHistory(item.name)"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="login-btn btn-animate" v-if="!isAliveFlag" @click="login()">登录</div>
          <div class="out-login" v-else>
            <img :src="userPhoto" alt="">
            <div class="select">
              <span class="user-nmae">{{userName}}</span>
              <span v-if="cmsFlag" @click="toCms">管理后台</span>
              <span @click="toLink('/learning','学习中心')">学习中心</span>
              <span @click="outLogin()">退出</span>
            </div>
          </div>
        </div>
        <div class="small-login-box" @click.stop="openSmallCont">
          <div class="menu-but">
            <span>菜单</span>
            <img src="@/image/index/icon-menu.png" alt="">
          </div>
          <div class="small-login-cont" v-if="isShowSmallCont">
            <div class="menu-close">
              <span>菜单</span>
              <img src="@/image/index/icon-menu-close.png" alt="">
            </div>
            <ul @click.stop>
              <li class="index-but" @click="toLink('/','首页')"><span>首页</span></li>
              <div v-if="navList && navList.length > 0">
                <li v-for="(item,index) in navList" :key="index" @click="toLink(`/multiplex/?id=${item.id}`,item.name)"><span>{{item.name}}</span></li>
              </div>
              <li @click="toLink('/scene/','学习路线')"><span>学习路线</span></li>
              <li @click="toLink('/about/','关于我们')"><span>关于我们</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="login-integral" v-if="LoginIntegralFlag">
      <div class="popup-cont">
        <img class="close-icon" src="@/image/icon-close.png" alt="" @click="closePopup">
        <img class="login-integral-icon" src="@/image/pic-login-integral.png" alt="">
        <p>欢迎你，登录成功，恭喜获得<span style='color:#e88f34;'>2积分！</span><br />（每日登录可获得积分哦）</p>
        <div class="close-btn" @click="closePopup">确定</div>
      </div>
    </div>
    <!-- <Assistant ref="assistant"></Assistant> -->
  </header>
</template>

<script>
import { setCookie } from "@/../public/public"
import { zhugeTrack,zhugeIdentify } from "@/../public/public";
import { axios } from '@/../api/init'
import { isMobile } from "@/../public/public"
import qs from 'qs'
// import Assistant from './assistant'
export default {
  name: "",
  components:{
    // Assistant
  },
  data() {
    return {
      userPhoto:'',
      userName:'',
      isAliveFlag:'',
      courseId:'',
      LoginIntegralFlag: false,
      isShowSmallCont: false,
      cmsFlag: false,
      navList:[], // 可编辑列表页
      searchOtherFlag: false, // 显示搜索热词、记录
      searchData:"", // 搜索内容
      // 热词
      hotList:[],
      // 本地搜索记录
      localHistoryList: JSON.parse(localStorage.getItem('localHistoryList')) || [],
    };
  },
  created() {
    this.IsAlive()
    this.getNavList()
    this.getHotList()
  },
  mounted() {
    let str = location.href
    this.courseId = str.substr(str.indexOf('=') + 1)
    let _this = this
    this.$nextTick(() => {
      document.onclick=function(){
        if(_this.isShowSmallCont){
          _this.isShowSmallCont = false
        }
      }
    });
    document.addEventListener('mousedown',this.hideOtherSeaarch)
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.hideOtherSeaarch);
  },
  methods: {
    toLink(path,name){
      this.isShowSmallCont = false
      if(path == this.$route.path) return
      if(this.$route.path == '/multiplex/' && path === `${this.$route.path}?id=${this.$route.query.id}`) return
      this.$router.push({
        path:path
      })
      zhugeTrack('Web_点击导航（编程站）',{
        "导航名称": name
      })
    },
    // 获取热词
    getHotList(){
      axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/bxg/search/hot-words",
        method: "GET",
        params: {channelType:1},
      }).then(res => {
        if(res.data.status == 200){
          this.hotList = res.data.result
        }
      })
    },
    // 搜索内容
    searchFun(data){
      if(!data && !this.searchData) return
      this.searchData = data ? data : this.searchData
      if(!this.searchData) return
      // 处理历史记录
      this.setHistory(this.searchData)
      this.$router.push({
        path:"/search",
        query:{
          str: encodeURIComponent(this.searchData) || encodeURIComponent(data),
          time: new Date().getTime()
        }
      })
      this.searchData = ""
      this.searchOtherFlag = false
    },
    // 显示其他搜索内容
    showOtherSeaarch(){
      this.searchOtherFlag = true
      this.setHistory()
    },
    // 隐藏其他搜索内容
    hideOtherSeaarch(){
      this.searchOtherFlag = false
    },
    // 清除历史记录
    deleteHistory(data){
      this.localHistoryList = JSON.parse(localStorage.getItem('localHistoryList'))
      if(data){
        this.localHistoryList.forEach((val, key)=>{
          if(data == val.name){
            this.localHistoryList.splice(key, 1)
          }
        })
        localStorage.setItem('localHistoryList',JSON.stringify(this.localHistoryList))
      }else{
        this.localHistoryList = []
        localStorage.setItem('localHistoryList','[]')
      }
    },
    // 历史记录处理
    setHistory(data){
      this.localHistoryList = JSON.parse(localStorage.getItem('localHistoryList'))
      if(!this.localHistoryList){
        this.localHistoryList = []
      }
      // 重复的搜索处理
      let isHas = false
      let index = null
      this.localHistoryList.forEach((val, key)=>{
        if(val.name == data){
          isHas = true
          index = key
        }
      })
      // 是否重复
      if(isHas){
        let newData = this.localHistoryList.splice(index, 1)
        this.localHistoryList.unshift({name: newData[0].name})
      }else{
        if(data){
          this.localHistoryList.unshift({name: data})
        }
      }
      // 更新localStorage
      localStorage.setItem('localHistoryList',JSON.stringify(this.localHistoryList))
    },
    IsAlive() {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET"
      }).then(res => {
        if (res.data.success) {
          this.isAliveFlag = true
          let result = res.data.resultObject
          zhugeIdentify(result.mobile,{
            "昵称": result.name
          });
          this.userPhoto = result.smallHeadPhoto
          this.userName = result.name
          let sign =  this.getSign()//解析cookie中的sign
          localStorage.setItem('sign',sign)
          localStorage.setItem('studentId',res.data.resultObject.id)
          // this.addIntegral(1)
          this.checkPower()
          zhugeTrack('Web_登录成功（编程站）')
          // this.$refs.assistant.getQrCode()
        } else {
          localStorage.removeItem('sign')
          localStorage.removeItem('studentId')
          this.isAliveFlag = false
        }
      });
    },
    getCookie(name) {
      //读取cookie
      var arr = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      );
      if (arr != null) return unescape(arr[2]);
      return null;
    },
    // 获取sign
    getSign() {
      var cookie = this.getCookie("_uc_t_");
      if (cookie != null) {
        var arr = cookie.split(";");
        return arr[2];
      }
      return null;
    },
    // 获取导航配置列表页
    getNavList(){
      axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + '/interactive-course/pages',
        method: 'GET',
      }).then(res=>{
        if(res.data.status == 200){
          this.navList = res.data.result
        }
      })
    },
    // 查询后台权限接口
    checkPower(){
      axios({
        url: VUE_APP_NEW_URL + "/commodity/auth/check",
        method: "GET"
      }).then(res => {
        if(res.data.code == 200){
          this.cmsFlag = res.data.data.accessAuth ? true : false
        }
      })
    },
    // 登录
    login(){
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET"
      }).then(res => {
        if(res.data.success){
          location.reload()
        }else{
          if(isMobile()){
            window.location.href = "/qrcode.html#/"
          }else{
            if(this.$route.path == '/' || this.$route.path == '/course'){
              zhugeTrack('Web_点击登录（编程站）')
              window.location.href =  VUE_APP_BASE_PATH_PASSPORT + "/user/login?refer=" + encodeURIComponent(location.protocol +'//'+ location.hostname + '/?isLogin=true') + '&codeLogin=true'
            }else{
              zhugeTrack('Web_点击登录（编程站）')
              window.location.href = VUE_APP_BASE_PATH_PASSPORT + "/user/login?refer=" + encodeURIComponent(window.location.href) + '&codeLogin=true'
            }
          }
        }
      })
    },
    // 退出
    outLogin(){
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/logout",
        method: "GET"
      }).then(res => {
        if(res.data.success){
          if(this.$route.name == 'learning'){
            localStorage.removeItem('sign');
            localStorage.removeItem('studentId');
            window.location.href = '/'
            location.reload()
            zhugeTrack('Web_登录退出（编程站）')
          }else{
            localStorage.removeItem('sign');
            localStorage.removeItem('studentId');
            location.reload()
            zhugeTrack('Web_登录退出（编程站）')
          }
        }
      })
    },
    // 后台管理
    toCms(){
      window.open('/subpage.html#/')
    },
    // 增加积分
    addIntegral(source){
      let time = new Date(new Date().getTime())
      let strTime = `${time.getFullYear()}-${time.getMonth()+1}-${time.getDate()}`
      let obj = {
        studentId: localStorage.getItem('studentId'),
        source: source,
        uniqueKey: strTime
      }
      axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/points",
        method: "POST",
        params: {
          sign: localStorage.getItem('sign'),
        },
        data: qs.stringify(obj)
      }).then(res => {
        if(res.data.status === 200){
          this.LoginIntegralFlag = true
          // setTimeout(()=>{
          //   this.LoginIntegralFlag = false
          // },2000)
        }
      })
    },
    // 关闭每日登录奖励积分弹框
    closePopup(){
      this.LoginIntegralFlag = false
    },
    // 打开小屏导航
    openSmallCont(){
      this.isShowSmallCont = !this.isShowSmallCont
    }
  },
  watch:{
    $route(val){
      if(!localStorage.getItem('sign') || !localStorage.getItem('studentId')){
        this.isAliveFlag = false
      }else{
        this.isAliveFlag = true
      }
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
li,
ul,
a,
p {
  text-transform: none;
  list-style: none;
  margin: 0;
  padding: 0;
}
input,
button {
  border: 0;
  outline: none;
}

header {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  position: relative;
  z-index:5;
  .header-mask{
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-shadow: 0 0 15px 1px rgba(87, 69, 69, 0.1);
  }
  .header-content {
    max-width: 1200px;
    padding: 0 15px;
    margin: 0 auto;
    .cont-left {
      float: left;
      padding: 12px 0;
      .logo-box {
        float: left;
        font-size: 0;
        cursor: pointer;
        padding: 4px 0;
        img {
          height: 28px;
          display: inline-block;
          vertical-align: middle;
        }
        span {
          margin-left: 10px;
          font-weight: 600;
          color: #333;
          font-size: 22px;
          line-height: 34px;
          display: inline-block;
          vertical-align: middle;
        }
        i{
          width:1px;
          height: 20px;
          display: inline-block;
          vertical-align: middle;
          background:#333;
          margin-left: 15px;
        }
        .learning-btn{
          margin-left: 15px;
          cursor: pointer;
        }
        .unchecked{
          color: #999;
        }
      }
      .nav-right{
        float: left;
        margin-left: 57px;
        .class-btn {
          font-size:15px;
          float: left;
          line-height: 36px;
          cursor: pointer;
          color: #25c48b;
          margin-left: 30px;
          position: relative;
        }
        .class-btn:first-child{
          margin-left: 0;
        }
        .nav-news{
          &:after{
            display: block;
            position: absolute;
            top: -4px;
            right: -20px;
            width: 20px;
            height: 10px;
            content:"";
            background: url(../../image/index/icon-nav-new.png) no-repeat;
            background-size: 100% 100%;
          }
        }
        .class-btn-shu{
          font-size:15px;
          float: left;
          display:block;
          margin: 0 16px;
          line-height: 52px;
        }
        .unchecked{
          color: #1B3056;
          &:hover{
            color: #25c48b;
          }
        }
        &:after {
          content: "";
          display: block;
          clear: both;
        }
      }
      @media (max-width: 820px) {
        .nav-right{
          margin-left: 20px !important;
          .class-btn{
            margin-left: 40px;
          }
        }
      }
    }
    .cont-login-box {
      float: right;
      display: flex;
      .search-box{
        margin-right: 34px;
        width: 180px;
        height: 60px;
        padding: 14px 0;
        position: relative;
        .search-cont{
          height: 32px;
          position: relative;
          background-color: #f4f6f8;
          border-radius: 16px;
          input{
            border:0;
            height: 20px;
            line-height: 20px;
            width: 125px;
            font-size: 14px;
            outline: none;
            background: transparent;
            position: absolute;
            left: 14px;
            top: 50%;
            margin-top: -10px;
            color: #818b9c;
            &::placeholder {
              color: #818b9c;
              font-size: 14px;
              line-height: 20px;
            }
          }
          i{
            width: 14px;
            height: 14px;
            position: absolute;
            top:50%;
            right: 15px;
            margin-top: -7px;
            display: block;
            background: url(../../image/index/icon-search.png) no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
        .search-other{
          position: absolute;
          top: 60px;
          right: 0;
          width: 300px;
          padding: 16px 0 16px 16px;
          background-color: #ffffff;
          border: solid 1px #dce0e4;
          padding-right: 16px;
          h4{
            font-size: 18px;
            color: #1b3056;
            line-height: 25px;
          }
          .hot-list{
            margin-top: 16px;
            display: flex;
            flex-wrap:wrap;
            li{
              background-color: #f4f8fd;
              border-radius: 2px;
              padding: 4px 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 10px 10px 0;
              cursor: pointer;
              i{
                width: 12px;
                height: 16px;
                background-color: #ff6969;
                margin-right: 6px;
                background: url(../../image/index/icon-fire.png) no-repeat;
                background-size: 100% 100%;
              }
              span{
                font-size: 14px;
                color: #1b3056;

              }
              &:hover{
                span{
                  color:#25c48b;
                }
              }
            }
          }
          .history-box{
            margin-top: 30px;
            .history-title{
              display: flex;
              justify-content: space-between;
              align-items: center;
              span{
                font-size: 14px;
                color: #818b9c;
                padding-right: 19px;
                position: relative;
                cursor: pointer;
                &:after{
                  display: block;
                  content:"";
                  width: 10px;
                  height: 10px;
                  position: absolute;
                  right:0;
                  top:50%;
                  margin-top: -5px;
                  background: url(../../image/index/icon-close.png) no-repeat;
                  background-size: 100% 100%;
                }
              }
            }
            .history-list{
              margin-top: 16px;
              li{
                margin-top: 10px;
                height: 28px;
                cursor: pointer;
                span{
                  display: inline-block;
                  background-color: #f4f8fd;
                  border-radius: 2px;
                  font-size: 14px;
                  padding: 0 10px;
                  height: 28px;
                  color: #1b3056;
                  line-height: 28px;
                  text-overflow:ellipsis;  
                  overflow: hidden;
                  white-space: nowrap;
                  max-width: 266px;
                }
                i{
                  display: none;
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  right:10px;
                  top:50%;
                  transform: translateY(-50%);
                  background: url(../../image/index/icon-close.png) no-repeat;
                  background-size: 10px 10px;
                  background-position: center;
                  cursor: pointer;
                }
                &:hover{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  position: relative;
                  background-color: #f4f8fd;
                  border-radius: 2px;
                  span{
                    width: 235px;
                    color: #25c48b;
                  }
                  i{
                    display: block;
                  }
                }
              }
              li:first-child{
                margin:0;
              }
            }
          }
        }
      }

      .cms-entry{
        width: 80px;
        height: 30px;
        margin-right: 20px;
        border-radius: 4px;
        border: solid 1px #25c48b;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #25c48b;
        line-height: 29px;
        box-sizing: border-box;
        margin-top: 15px;
        text-align: center;
        cursor: pointer;
        &:hover{
          border: solid 1px #28D899;
          color: #28D899;
        }
      }
      .login-btn {
        width: 90px;
        height: 32px;
        line-height: 32px;
        background: #25C48B;
        margin: 14px 0;
        border-radius: 4px;
        text-align: center;
        font-size: 15px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .out-login{
        height: 60px;
        padding: 12px 12px;
        width: 60px;
        position: relative;
        background:#fff;
        text-align: right;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        img{
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #fff;
          border:1px solid #fff;
          box-sizing: border-box;
        }
        .select{
          display:none;
          position: absolute;
          right:0;
          top:59px;
          width: 180px;
          box-shadow: 0 0 10px 0 #A4AAB8;
          z-index:10;
          span{
            display: block;
            height: 50px;
            color: #2A3C60;
            font-size: 14px;
            line-height: 50px;
            background: #fff;
            padding-left:20px;
            text-align: left;
            box-sizing: border-box;
            &:hover{
              background: #25C48B;
              color: #fff;
            }
          }
          .user-nmae{
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            cursor: default;
            border-bottom: 1px solid rgba(127, 136, 151, 0.2);
            text-overflow:ellipsis;  
            overflow: hidden;  
            white-space: nowrap;
            font-weight: 600;
            &:hover{
              color: #2A3C60;
              background: #fff;
            }
          }
        }
        &:hover {
          background: #F6FAFD;
          .select{
            display:block;
          }
        }
      }
    }
    .small-login-box{
      display: none;
      float: right;
      height: 60px;
      position: relative;
      padding: 15px 0;
      .menu-but{
        display: flex;
        align-items: center;
        cursor: pointer;
        span{
          font-size: 16px;
          color: #25C48B;
          line-height: 30px;
        }
        img{
          display: block;
          width: 16px;
          height: 14px;
          margin-left: 10px; 
        }
      }
      .small-login-cont{
        // display: none;
        position: fixed;
        width: 100%;
        height: 100%;
        top:0;
        left:0;
        background: rgba(0,0,0,.4);
        z-index:5;
        .menu-close{
          position: absolute;
          top:15px;
          right: 15px;
          display: flex;
          align-items: center;
          z-index:2;
          cursor: pointer;
          span{
            font-size: 16px;
            color: #25C48B;
            line-height: 30px;
          }
          img{
            display: block;
            width: 16px;
            height: 16px;
            margin-left: 10px; 
          }
        }
        ul{
          position: absolute;
          top:0;
          right:0;
          width: 50%;
          // height: 100%;
          padding: 60px 15px 0;
          background: #fff;
          // animation: navShow .5s ease;
          overflow: hidden;
          li{
            font-size: 16px;
            box-sizing: border-box;
            padding: 15px 0;
            border-bottom: 1px solid #DCDFE4;
            span{
              display: inline-block;
              color: #1B3056;
              cursor: pointer;
              &:hover{
                color: #28D899;
              }
            }
          }
          >li:last-child{
            border:0;
          }
        }

      }
      @keyframes navShow {
        from{
          height: 60px;
        }
        to{
          height: 279px;
        }
      }
    }
    &:after {
      content: "";
      display: block;
      clear: both;
    }
  }
}

@media (max-width: 1190px) {
  header{
    .header-content{
      .cont-left{
        padding: 12px 0;
        .logo-box{
          img{
            height: 28px !important;
          }
        }
      }
      .nav-right{
        display: none !important;
      }
      .cont-login-box{
        display: none !important;
      }
      .small-login-box{
        display: block;
      }
    }
  } 
}

.login-integral{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 20;
  .popup-cont{
    width: 360px;
    background: #fff;
    border-radius: 8px;
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    box-sizing: border-box;
    padding: 30px;
    text-align: center;
    .close-icon{
      width: 14px;
      height: 13px;
      cursor: pointer;
      position: absolute;
      top: 15px;
      right: 15px;
    }
    .login-integral-icon{
      width: 64px;
      height: 50px;
    }
    p{
      margin-top: 20px;
      font-size: 14px;
      color: #000;
      text-align: center;
    }
    .close-btn{
      margin: 26px auto 0;
      width: 90px;
      height: 36px;
      background-color: #25c48b;
      border-radius: 4px;
      color: #fff;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      &:hover{
        background-color: #28D899;
      }
    }
  }
}

.btn-animate{
	position: relative;
	height: 56px;
	text-align: center;
	line-height: 56px;
	cursor: pointer;
	font-size: 16px;
	color: #fff;
	background: #25C48B;
	border-radius: 4px;
	overflow: hidden;
	&::after{
		position: absolute;
		top:0;
		left:-10px;
		content:"";
		display: block;
		transform: skewX(25deg);
		width: 56%;
		height: 100%;
		background-color: #fff;
		opacity: .1;
		transition: .3s ease-in;
	}
	&:hover{
		&::after{
			opacity: .2;
			width: 100%;
			left:0;
			transform: skewX(0deg);
		}
	}
}
</style>